<template>
    <div class="users">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>客户设备状态</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="margin-top: 1rem; padding: 1.5rem 1rem 0 1rem; background-color: white">
            <el-form :inline="true" :model="query">
                <el-form-item label="所属企业:">
                    <el-select v-model="query.epId" filterable placeholder="请选择">
                        <el-option
                                v-for="item in enterprises"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onQuery">查询</el-button>
                    <el-button type="default" @click="query = {}">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="margin-top: 1rem; padding: 1rem; background-color: white">
            <el-button type="primary" style="margin-bottom: 1rem" @click="$router.push('/deviceStandard/recharge')" size="small" v-if="auth.accountType != 1">客户设备充值</el-button>
            <el-table
                    :data="devices"
                    border
                    stripe
                    v-loading="loading"
                    style="width: 100%">
                <el-table-column
                        sortable
                        :sort-method="(a, b) => a.deviceName ? a.deviceName.localeCompare(b.deviceName, 'zh') : -1"
                        prop="deviceName"
                        label="设备名称">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="deviceType"
                        label="设备型号">
                </el-table-column>
                <el-table-column
                        sortable
                        :sort-method="(a, b) => a.epName ? a.epName.localeCompare(b.epName, 'zh') : -1"
                        prop="epName"
                        label="所属企业">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="price"
                        label="充值价格">
                    <template slot-scope="scope">
                        {{scope.row.price}}元/次
                    </template>
                </el-table-column>
                <el-table-column
                        sortable
                        prop="useableCount"
                        label="可用次数">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="createTime"
                        label="创建时间">
                </el-table-column>
            </el-table>
            <div style="text-align: center">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pagination.page"
                        :page-sizes="[10, 20, 50, 100, 200]"
                        :page-size="pagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import deviceApi from "../../api/deviceStandard";
    import enterpriseApi from "../../api/enterprise";
    import {mapState} from "vuex";

    export default {
        data: function () {
            return {
                devices: [],
                enterprises: [],
                loading: false,
                total: 0,
                pagination: {
                    page: sessionStorage.getItem("page") || 1,
                    pageSize: 10
                },
                query: {

                },
            }
        },
        computed: {
            ...mapState("auth", {
                auth: state => state
            }),
        },
        mounted() {
            this.loadUsers();
            this.loadEnterprises();
        },
        methods: {
            deleteDevice: function(id) {
                this.$confirm('确定删除此设备类型？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    deviceApi.deleteById(id).then(result => {
                        this.loading = false;
                        this.loadUsers();
                    })
                });
            },
            loadUsers: function () {
                this.loading = true;
                deviceApi.getAll(this.query, this.pagination).then(result => {
                    this.loading = false;
                    this.devices = result.data;
                    this.total = result.total;
                })
            },
            onQuery: function () {
                this.pagination = {
                    page: 1,
                    pageSize: 10
                }
                this.loadUsers();
            },
            handleSizeChange: function (size) {

                this.pagination = {
                    page: 1,
                    pageSize: size
                }
                this.loadUsers();
            },
            handleCurrentChange: function (page) {
                sessionStorage.setItem("page", page);
                this.pagination = {
                    ...this.pagination,
                    page: page,
                }
                this.loadUsers();
            },
            loadEnterprises: function () {
                enterpriseApi.getAll2().then(res => {
                    this.enterprises = res;
                })
            }
        }
    }
</script>
